import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'viva-back-button',
  templateUrl: './viva-back-button.component.html',
  styleUrls: ['./viva-back-button.component.scss'],
  standalone: false,
})
export class VivaBackButtonComponent {
  /** i18n key for aria-label (default: shared back label). */
  @Input() ariaLabelKey = 'viva-back-button-component.aria.back';
  /** Additional CSS classes (e.g. layout-back-button, startup-header-back). */
  @Input() cssClass = 'layout-back-button';
  @Input() fill?: string;
  @Input() iconColor?: string;
  @Input() useIconOnlySlot = true;

  @Output() backClick = new EventEmitter<void>();

  onBack(): void {
    this.backClick.emit();
  }

  onKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.onBack();
    }
  }
}
